
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DadosCliente } from "@/types";
import { ArrowLeft } from "lucide-react";
import ClienteSolarForm from "@/components/clientes/ClienteSolarForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface DadosClienteFormProps {
  onDadosSalvos: (dados: DadosCliente) => void;
  dadosIniciais?: DadosCliente;
  onVoltar?: () => void;
}

export const DadosClienteForm = ({ onDadosSalvos, dadosIniciais, onVoltar }: DadosClienteFormProps) => {
  const [nome, setNome] = useState(dadosIniciais?.nome || "");
  const [registroMode, setRegistroMode] = useState("rapido");
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validação básica
    if (!nome.trim()) {
      return;
    }
    
    const dadosCliente: DadosCliente = {
      nome,
      telefone: "",
      email: "",
      cpf: "",
      tipo: 'solar'
    };
    
    onDadosSalvos(dadosCliente);
  };

  // Handler para dados salvos do formulário solar completo
  const handleSolarFormSave = (clientData: any) => {
    const dadosSimplificados: DadosCliente = {
      nome: clientData.nome,
      telefone: clientData.celular || "",
      email: clientData.email || "",
      cpf: clientData.documento || "",
      tipo: 'solar'
    };
    
    onDadosSalvos(dadosSimplificados);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Dados do Cliente</CardTitle>
          <CardDescription>Informe os dados básicos do cliente</CardDescription>
        </div>
        {onVoltar && (
          <Button
            variant="outline"
            size="sm"
            onClick={onVoltar}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" /> Voltar
          </Button>
        )}
      </CardHeader>
      <CardContent>
        <Tabs value={registroMode} onValueChange={setRegistroMode} className="w-full">
          <TabsList className="grid grid-cols-2 mb-6">
            <TabsTrigger value="rapido">Cadastro Rápido</TabsTrigger>
            <TabsTrigger value="completo">Cadastro Completo</TabsTrigger>
          </TabsList>
          
          <TabsContent value="rapido">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid gap-2">
                <Label htmlFor="nome">Nome</Label>
                <Input
                  id="nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Nome completo"
                  required
                />
              </div>
              
              <Button type="submit" className="w-full">
                Salvar Dados
              </Button>
            </form>
          </TabsContent>
          
          <TabsContent value="completo">
            <div className="p-2 bg-yellow-50 rounded-md mb-4 text-sm">
              Por favor, preencha o formulário completo para o cliente solar. Apenas o nome, telefone, email e CPF serão usados para a calculadora.
            </div>
            
            <div className="custom-form-wrapper">
              <ClienteSolarForm />
              
              <div className="mt-4 flex justify-center">
                <Button 
                  onClick={() => {
                    // Criar dados simplificados a partir do form
                    if (nome) {
                      const dadosSimplificados: DadosCliente = {
                        nome,
                        telefone: "",
                        email: "",
                        cpf: "",
                        tipo: 'solar'
                      };
                      onDadosSalvos(dadosSimplificados);
                    } else {
                      // Aqui precisamos de pelo menos o nome
                      alert("Por favor, informe pelo menos o nome do cliente");
                    }
                  }}
                  className="w-full"
                >
                  Continuar para Próxima Etapa
                </Button>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
